import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';
import { DATASTRATEGY } from '@dch/entity-manager';
import { LocalForageStrategy } from '@dch/entity-manager/lib/storage/strategies/local-forage.strategy';
import { SessionStorageStrategy } from '@dch/entity-manager/lib/storage/strategies/session-storage.strategy';
import { CryptoJsProviderStrategy } from '@dch/entity-manager/lib/encryption/cryptoJsProviderStrategy';

function _window() {
    return window;
}
class WindowRef {
    get nativeWindow() {
        return _window();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WindowRef, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WindowRef, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WindowRef, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const entityManagerConfiguration = {
    application: undefined,
    storageStrategies: {
        localForage: new LocalForageStrategy(),
        sessionStorage: new SessionStorageStrategy(),
    },
    selectedEncryptionStrategy: CryptoJsProviderStrategy(),
    timeout: 10000,
    language: {
        selectLanguageFunction: () => {
            return Cookies.get('LANGUAGE') || window.language || 'en';
        },
        languageStorageStrategyId: LocalForageStrategy.ID,
    },
    defaultEntityConfiguration: {
        version: 'v1',
        dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
        storageStrategy: LocalForageStrategy.ID,
    },
    jwtStorageStrategyId: SessionStorageStrategy.ID,
    onErrorCallback: (entity) => {
        console.error('Error occurred while calling uService for entity: ', entity);
    },
};

// FIXME: see where to put these values
// prettier-ignore
const emailFormatRegEx = '^[A-Za-z0-9!#$%&amp;\'*+\\/=?^_`{|}~.-]+@[a-z0-9-]+(\\.[a-z0-9-]+){1,2}$';
const defaultDomain = 'proximus.be';
const msisdnNationalNumberFormatRegEx = '(04)+[0-9]{8}$';

/**
 * Generated bundle index. Do not edit.
 */

export { WindowRef, defaultDomain, emailFormatRegEx, entityManagerConfiguration, msisdnNationalNumberFormatRegEx };
